import React from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";

/**
 * onOptionChange: dipanggil dengan OBJEK opsi yang dipilih, bukan sekadar
 * nilainya, setelah nilai form diperbarui. Berguna bila opsi membawa data
 * tambahan - mis. daftar perusahaan yang ikut membawa alamat dan koordinat
 * untuk mengisi kolom lain secara otomatis. Dipanggil dengan null saat
 * pilihan dikosongkan.
 */
export default function ControlledReactSelect({ options, isLoading, control, name, label, isMulti, isDisabled = false, defaultValue, menuPosition = "fixed", menuPortalTarget = null, isRequired = true, onOptionChange }) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const selectedValue = isMulti ? options?.filter((option) => field.value?.includes(option.value)) : options?.find((option) => option.value === field.value);

        return (
          <div className="flex flex-col gap-1">
            {label && (
              <label className={`text-sm ${isDisabled ? "opacity-50" : ""}`}>
                {label} {isRequired && <span className="text-danger">*</span>}
              </label>
            )}
            <Select
              {...field}
              placeholder="Cari..."
              options={options}
              isMulti={isMulti}
              isClearable
              isSearchable={true}
              isLoading={isLoading}
              isDisabled={isDisabled}
              value={selectedValue}
              menuPosition={menuPosition}
              menuPortalTarget={menuPortalTarget}
              onChange={(option) => {
                const value = isMulti ? option?.map((item) => item.value) : option?.value;
                field.onChange(value);
                if (typeof onOptionChange === "function") onOptionChange(option ?? null);
              }}
              styles={{
                menu: (styles) => ({
                  ...styles,
                  zIndex: 9999,
                }),
                menuPortal: (styles) => ({
                  ...styles,
                  zIndex: 9999,
                }),
                control: (styles) => ({
                  ...styles,
                  backgroundColor: "#EBF2F0",
                }),
                option: (styles) => ({
                  ...styles,
                  color: "#51625E",
                  fontSize: "10pt",
                }),
                placeholder: (styles) => ({
                  ...styles,
                  color: "#51625E",
                  fontSize: "10pt",
                }),
                multiValue: (styles) => ({
                  ...styles,
                  backgroundColor: "#C7D2CF",
                  borderRadius: 5,
                }),
                indicatorSeparator: (styles) => ({
                  ...styles,
                  alignSelf: "stretch",
                  marginBottom: 8,
                  marginTop: 8,
                  width: 2,
                  backgroundColor: "#E1E8E6",
                }),
              }}
            />
            {fieldState.error && <p className="text-danger text-xs">{fieldState.error.message}</p>}
          </div>
        );
      }}
    />
  );
}
